import React, { useState, useContext } from "react";
import styled from "styled-components";
import Input from "../../../../../components/input";
import Button from "../../../../../components/button";
import Modal from "../../../../../components/modal";
import PersonAdd from "@material-ui/icons/PersonAdd";
import { createSubAccount, loadProfile } from "../../../../../api";
import { AuthContext } from "../../../../../auth-context";
import { DashboardContext } from "../../../dashboard-context";
import { ErrorMessage } from "../../../../../components/error-message";

const Container = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  width: 540px;
  padding: 24px;

  @media (max-width: 900px) {
    padding: 16px;
  }
`;

const Label = styled.label`
  color: #555;
  display: flex;
  align-items: center;
  font-family: ${(props) => props.theme.font.primary};
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 24px;

  svg {
    fill: #555;
    height: auto;
    width: 36px;
    margin-right: 16px;
  }

  @media (max-width: 900px) {
    font-size: 1.25rem;
    margin-bottom: 16px;

    svg {
      width: 28px;
    }
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ClearButton = styled(Button)`
  background: none;
  box-shadow: none;
  color: #888;
  margin: 0;

  &:hover {
    background: #efefef;
  }

  &:active {
    background: #ddd;
    box-shadow: none;
    color: #555;
  }
`;

const AddButton = styled(Button)`
  margin: 0;
  margin-left: 16px;
`;

const AccountsTable = (props) => {
  const { user, updateUser } = useContext(AuthContext);
  const { openSnackbar } = useContext(DashboardContext);
  const [email, updateEmail] = useState("");
  const [name, updateName] = useState("");
  const [error, updateError] = useState(false);
  const [modal1, updateFirstModal] = useState(false);
  const [showPaymentModal, updatePaymentModal] = useState(false);

  const handleFirstModal = () => {
    if (user.defaultCard.last4 === "" && user.role_id === 1) {
      updatePaymentModal(true);
    } else if (email !== "" && name !== "" && emailIsValid(email)) {
      updateFirstModal(true);
      updateError(false);
    } else {
      updateError(true);
    }
  };

  const emailIsValid = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleAdd = () => {
    if (email !== "" && name !== "" && emailIsValid(email)) {
      createSubAccount(user.id, email, name)
        .then(() => {
          updateFirstModal(false);
          openSnackbar("Member successfully added.", false);

          loadProfile(user.id)
            .then((res) => {
              if (res.data.profile.active === 1) {
                updateUser(res.data.profile);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
          updateError(false);
          openSnackbar("There was a problem creating this team member.", true);
        });
    } else {
      updateError(true);
    }
  };

  return (
    <React.Fragment>
      <Container className={props.className}>
        <HeaderContainer>
          <Label>
            <PersonAdd /> Add a New Team Member
          </Label>
        </HeaderContainer>
        <Input
          error={Boolean(error)}
          label="Email"
          type="email"
          autoComplete="email"
          value={email}
          onChange={updateEmail}
        />
        <Input
          error={Boolean(error)}
          label="Full Name"
          value={name}
          onChange={updateName}
        />

        {error && <ErrorMessage>Email or name missing</ErrorMessage>}
        <ButtonContainer>
          <ClearButton
            label="Clear"
            onClick={() => {
              updateEmail("");
              updateName("");
              updateError(false);
            }}
          />
          <AddButton label="Add Team Member" onClick={handleFirstModal} />
        </ButtonContainer>
        <Modal
          title="Are you sure this info is correct?"
          submitLabel="Confirm"
          open={modal1}
          onClose={() => updateFirstModal(false)}
          handleSubmit={handleAdd}
        >
          <Input
            error={Boolean(error)}
            label="Email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={updateEmail}
          />
          <Input
            error={Boolean(error)}
            label="Full Name"
            value={name}
            onChange={updateName}
          />
        </Modal>
        <Modal
          hideAction
          warning
          title="Missing payment information"
          message="Before you can start adding accounts, you must enter a payment method on the My Profile page."
          open={showPaymentModal}
          onClose={() => updatePaymentModal(false)}
        />
      </Container>
    </React.Fragment>
  );
};

export default AccountsTable;
